import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '../icon';

export interface Breadcrumb {
  name: string;
  navigate?: string[];
  icon?: string;
  onClick?: (event: MouseEvent) => void;
  queryParams?: { [key: string]: any };
}

@Component({
  selector: 'spx-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  imports: [CommonModule, IconComponent, RouterModule, FlexLayoutModule, TranslateModule],
})
export class BreadcrumbsComponent {
  @Input() root: Breadcrumb | null = {
    name: '',
    navigate: ['/'],
    icon: 'icon-home',
  };
  @Input() breadcrumbs!: Breadcrumb[];
}
